import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import PublicRoute from './router/publicRoutes'
import PrivateRoute from './router/privateRoutes'
import { authRoutes, unAuthRoutes } from './router/routes'
import Layout from './layout'
import NotFound from './pages/notFound'

const AppContainer = () => {
  const isDirectLoad = window.performance && window.performance.navigation.type === 0
  useEffect(() => {}, [isDirectLoad])

  return (
    <>
      <Routes>
        {unAuthRoutes?.map((route, idx) => (
          <Route key={idx} path={route?.path} element={<PublicRoute>{route?.element}</PublicRoute>} />
        ))}
        <Route element={<Layout />}>
          {authRoutes?.map((route, idx) =>
            route?.path ? (
              <Route key={idx} path={route?.path} element={<PrivateRoute permission={route?.permission}>{route?.element}</PrivateRoute>} />
            ) : null,
          )}
          <Route path="*" element={<PrivateRoute><NotFound /></PrivateRoute>} />
        </Route>
      </Routes>
    </>
  )
}

export default AppContainer
